import WorkerWorkloadList from './WorkerWorkloadList';

const workerWorkload = {
    list: (props) => <WorkerWorkloadList {...props} />,
};

export default workerWorkload;
